import { makeStyles } from '@material-ui/core/styles';
import logo from 'assets/amzetta-logo.png'

export default makeStyles((theme) => {
    return {
        paper: {
            marginTop: theme.spacing(8),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        loaderContainer: {
            height: '30vh'
        },
        logo: {
            backgroundImage: `url(${logo})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: 60,
            width: 205
          },
    }
}, { index: 1 });